import { render, staticRenderFns } from "./test.vue?vue&type=template&id=1ed7c690&scoped=true"
var script = {}
import style0 from "./test.vue?vue&type=style&index=0&id=1ed7c690&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed7c690",
  null
  
)

export default component.exports